import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    search: '',
    search2: '',
}

export const searchReducer = createSlice({
    name: 'searchReducer',
    initialState,
    reducers: {
        setSearch: (state, action) => {
            state.search = action.payload
        },
        setSearch2: (state, action) => {
            state.search2 = action.payload
        },

    },
})

export const { setSearch, setSearch2 } = searchReducer.actions

export default searchReducer.reducer
